import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Study_Program_Card.css";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";
import { IDS } from "../../../../utils/IDS";

const Study_Program_Card = ({
  universityLogo,
  universityName,
  programImage,
  programName,
  description,
  countryFlag,
  duration,
  documents = [],
  fees,
  feesCurrency,
  onViewDetails,
  showBadge = false,
  badgeText = "Under Review",
}) => {
  return (
    <div className="program_card common_doc_card">
      {/* University Header */}
      <div className="university_header">
        {/* <img src={universityLogo} alt="logo" className="university_logo" /> */}
        <img
          src={universityLogo ? IDS.IMG_URL + universityLogo : ""}
          alt="logo"
          className="university_logo"
        />
        <h5 className="university_name">{universityName}</h5>

        {showBadge && <span className="status_badge">{badgeText}</span>}
      </div>

      {/* Program Image */}
      <div className="card_img_holder">
        {/* <img src={programImage} alt="program" className="program_image" /> */}
        <img
          src={programImage ? IDS.IMG_URL + programImage : ""}
          alt="program"
          className="program_image"
        />
      </div>

      {/* Body */}
      <div className="card_body">
        <div className="program_title_row">
          <h6 className="program_name">{programName}</h6>
          {/* <img src={countryFlag} alt="flag" className="country_flag" /> */}
          <img
            src={countryFlag ? IDS.IMG_URL + countryFlag : ""}
            alt="flag"
            className="country_flag"
          />
        </div>

        <p className="program_description">{description}</p>

        <div className="duration_fees_row">
          <Row>
            <Col>
              <p className="label">Duration:– {duration}</p>
            </Col>
            <Col className="text_end">
              <p className="label">
                Fees:– {feesCurrency} {fees}
              </p>
            </Col>
          </Row>
        </div>

        {/* Documents */}
        <div className="documents_block">
          <h6>Documents Submitted</h6>
          {documents.map((item, index) => {
            return (
              <div key={index} className="document_item">
                {/* <p className="list_text">{item.doc}</p> */}
                <p className="list_text">{item.Requirement_Document?.name}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Button */}
      <div className="btn_holder">
        <Blue_btn btn_text="View Details" onClick={onViewDetails} />
      </div>
    </div>
  );
};

export default Study_Program_Card;
